<mat-icon
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  class="tooltip-icon"
  [ngClass]="iconClass"
  [class.tooltip-icon--error]="type === 'error'"
  (mouseenter)="isOpen = true"
  (mouseleave)="isOpen = false">{{ icon }}</mat-icon>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions">
  <div class="tooltip-icon-panel">
    <ng-content></ng-content>
  </div>
</ng-template>
